import { render } from "./InProgressIcon.vue?vue&type=template&id=71321f0b"
import script from "./InProgressIcon.vue?vue&type=script&lang=js"
export * from "./InProgressIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__